import { defineMessages } from 'react-intl';

export default defineMessages({
  login: {
    id: 'cboard.components.WelcomeScreen.login',
    defaultMessage: 'Login'
  },
  signUp: {
    id: 'cboard.components.WelcomeScreen.signUp',
    defaultMessage: 'Sign Up'
  },
  facebook: {
    id: 'cboard.components.WelcomeScreen.facebook',
    defaultMessage: 'Sign in with Facebook'
  },
  google: {
    id: 'cboard.components.WelcomeScreen.google',
    defaultMessage: 'Sign in with Google'
  },
  apple: {
    id: 'cboard.components.WelcomeScreen.apple',
    defaultMessage: 'Sign in with Apple'
  },
  skipForNow: {
    id: 'cboard.components.WelcomeScreen.skipForNow',
    defaultMessage: 'Skip for now'
  },
  loginErrorAndroid: {
    id: 'cboard.components.WelcomeScreen.loginErrorAndroid',
    defaultMessage:
      'Sorry. An error occurred during authenticate process. Please try it again'
  },
  privacy: {
    id: 'cboard.components.WelcomeScreen.privacy',
    defaultMessage: 'Privacy Policy'
  },
  terms: {
    id: 'cboard.components.WelcomeScreen.terms',
    defaultMessage: 'Terms of service'
  }
});
